import React from 'react'

export const EngineContext = React.createContext(/* {engine: { }} */)
